<style lang="scss" scoped="">

  .order-list-item {
    cursor: pointer;
  }

  .header-list {
    overflow: hidden;
  }

  .opera-btn-group {
    margin-left: 0;
    margin-right: 0;

    .title {
      color: red;
    }
  }

  .is-flex {
    display: flex;
    align-items: center;
  }

  .advanced-query-form {
    > .el-row {
      margin-bottom: 10px;
    }
  }
</style>
<style lang="scss">
  .adjust-const-stock-detail {
    h3 {
      background: #fff;
      margin: 50px 0 0;
      padding: 5px;
      text-align: center;
    }

    .el-table__row {
      cursor: auto;
    }
  }
</style>
<template>
  <div class="order-page">
    <div class="container">
      <el-alert
        title="请选择货品主档和批号输入调整部分库存数，如果是正数则增加库存，如果是负数则减少库存。"
        type="warning">
      </el-alert>
      <div class="opera-btn-group" :class="{up:!showSearch}">
        <div class="opera-icon">
          <des-btn icon="back" perm="show" @click="$router.push('/store/adjust')">返回</des-btn>
        </div>
        <el-form class="advanced-query-form" onsubmit="return false">
          <el-row>
            <el-col :span="8">
              <oms-form-row :span="6" label="货品主档" isRequire>
                <goods-select :remote-method="queryManageGoods" placeholder="请输入名称搜索货品主档"
                              v-model="searchWord.goodsId" :list="dhsGoodsList" @change="orgGoodsChange"></goods-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="批号" :span="5" isRequire>
                <el-select v-model="searchWord.batchNumberId" filterable clearable remote @change="batchNumberChange"
                           :remoteMethod="queryDhsBatchNumbers" placeholder="请输入批号名称搜索批号">
                  <el-option v-for="item in batchNumberList" :value="item.id" :key="item.id" :label="item.batchNumber">
                    {{ item.batchNumber }}
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="供货单位" :span="5">
                <el-select filterable remote placeholder="请输入名称搜索供货单位" :remote-method="queryFactoryList"
                           :clearable="true"
                           v-model="searchWord.supplyManufacturersId" popperClass="good-selects"
                           @click.native.once="queryFactoryList('')" @change="supplyManufacturersIdChange">
                  <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in factoryList">
                    <div style="overflow: hidden">
                      <span class="pull-left" style="clear: right">{{org.name}}</span>
                    </div>
                    <div style="overflow: hidden">
                      <span class="select-other-info pull-left">
                        <span>系统代码:</span>{{org.manufacturerCode}}
                      </span>
                    </div>
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>

          </el-row>
          <el-row>
            <el-col :span="8">
              <oms-form-row label="物流中心" :span="6">
                <el-select filterable remote placeholder="请输入名称搜索物流中心" @change="logisticsCentreChange"
                           :remote-method="queryLogisticsCenter" :clearable="true"
                           v-model="searchWord.logisticsCentreId" popperClass="good-selects"
                           @click.native.once="queryLogisticsCenter('')">
                  <el-option :value="org.id" :key="org.id" :label="org.name" v-for="org in logisticsCenter">
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="业务合格库存" :span="8">
                <el-input type="number" v-model.number="form.availableCount"></el-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="业务不合格库存" :span="8">
                <el-input type="number" v-model.number="form.unqualifiedBizCount"></el-input>
              </oms-form-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <oms-form-row label="在途库存" :span="6">
                <el-input type="number" v-model.number="form.transitCount"></el-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="实际合格库存" :span="8">
                <el-input type="number" v-model.number="form.qualifiedCount"></el-input>
              </oms-form-row>
            </el-col>
            <el-col :span="8">
              <oms-form-row label="实际不合格库存" :span="8">
                <el-input type="number" v-model.number="form.unqualifiedCount"></el-input>
              </oms-form-row>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <oms-form-row label="调整原因" :span="6">
                <el-select filterable placeholder="请选择" clearable @change="reasonChange"
                           v-model="form.reason" popperClass="good-selects">
                  <el-option :value="item.key" :key="item.key" :label="item.label" v-for="item in adjustReason">
                  </el-option>
                </el-select>
              </oms-form-row>
            </el-col>
            <el-col :span="12" v-if="form.reason === '0'">
              <oms-form-row label="备注" :span="3">
                <el-input type="input" v-model="form.remark"></el-input>
              </oms-form-row>
            </el-col>
            <el-col :span="4">
              <oms-form-row label="" :span="2">
                <el-button type="primary" @click="onSubmit" :disabled="doing">调整库存</el-button>
              </oms-form-row>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <el-table :data="batches" class="header-list store border-black" border @row-click="showDetail"
                :header-row-class-name="'headerClass'" v-loading="loadingData" style="width: 100%">
        <el-table-column prop="logisticsCentreName" label="物流中心" min-width="160" :sortable="true">
          <template slot-scope="scope">
            <span>{{scope.row.logisticsCompanyName}}</span>
            <span v-show="scope.row.logisticsCentreName">-{{scope.row.logisticsCentreName}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="orgName" label="货主" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="goodsName" label="货品" min-width="200" :sortable="true"></el-table-column>
        <el-table-column prop="supplyManufacturersName" label="供货单位" min-width="160" :sortable="true"></el-table-column>
        <el-table-column prop="batchNumber" label="批号" :sortable="true" width="110"></el-table-column>

        <el-table-column label="业务库存" align="center">
          <el-table-column prop="availableCount" label="合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.availableCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unqualifiedBizCount" label="不合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.unqualifiedBizCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="undeterminedCount" label="业务停销" :render-header="formatHeader" :sortable="true"
                           width="110">
            <template slot-scope="scope">
              <span>{{scope.row.undeterminedCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>


        <el-table-column label="实物库存" align="center">
          <el-table-column prop="qualifiedCount" label="合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.qualifiedCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="unqualifiedCount" label="不合格" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.unqualifiedCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="transitCount" label="在途库存" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.transitCount}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="库存总数" :render-header="formatHeader" :sortable="true"
                           width="100">
            <template slot-scope="scope">
              <span>{{scope.row.totalCount}}</span>
            </template>
          </el-table-column>
        </el-table-column>


        <el-table-column prop="expiryDate" label="有效期" :sortable="true" width="110">
          <template slot-scope="scope">
            <span>{{ scope.row.expiryDate | date}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="expiryDate" label="创建时间" :sortable="true" width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.createTime | time}}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <page-right :show="showDetailPart" @right-close="resetRightBox" :css="{'width':'1000px','padding':0}">
      <detail :currentItem="currentItem" @close="resetRightBox"></detail>
    </page-right>
  </div>
</template>
<script type="text/jsx">
  //  import order from '../../../tools/orderList';
  import {BspStock} from '@/resources';
  import detail from './detail.vue';
  import OmsRow from '@dtop/dtop-web-common/packages/row';
  import MethodsMix from '@/mixins/methodsMinix';

  export default {
    mixins: [MethodsMix],
    components: {
      OmsRow,
      detail
    },
    data() {
      return {
        loadingData: false,
        showSearch: true,
        showDetailPart: false,
        batches: [],
        filters: {
          batchNumberId: '',
          goodsId: '',
          warehouseId: '',
          showFlag: true,
          supplyManufacturersId: ''
        },
        searchWord: {
          batchNumberId: '',
          goodsId: '',
          warehouseId: '',
          showFlag: true,
          supplyManufacturersId: ''
        },
        factories: [], // 厂商列表
        orgList: [], // 货主列表,
        orgGoods: [],
        pager: {
          currentPage: 1,
          count: 0,
          pageSize: 10
        },
        currentItemId: '',
        currentItem: {},
        totalInfo: {},
        statusTitle: [
          '已过期',
          '即将到期',
          '正常'
        ],
        statusType: [
          'danger',
          'warning',
          'primary'
        ],
        batchNumberList: [],
        warehouses: [],
        form: {
          availableCount: '',
          qualifiedCount: '',
          transitCount: '',
          unqualifiedCount: '',
          undeterminedCount: '',
          reason: '',
          remark: ''
        },
        doing: false,
        operateList: [],
        loadingLog: false
      };
    },
    computed: {
      bodyHeight: function () {
        let height = parseInt(this.$store.state.bodyHeight, 10);
        height = height - 110;
        return height;
      },
      adjustReason() {
        return this.$getDict('adjustReason');
      }
    },
    methods: {
      isValid(item) {
        let a = this.$moment();
        let b = this.$moment(item.expiryDate);
        let days = b.diff(a, 'days');
        return a < b ? days > 90 ? 2 : 1 : 0;
      },
      getBatches() { // 得到波次列表
        let params = Object.assign({}, this.filters);
        this.loadingData = true;
        BspStock.queryOrgStock(params).then(res => {
          this.batches = res.data.list;
          this.loadingData = false;
        });
      },
      reasonChange() {
        this.form.remark = '';
      },
      formatHeader(h, col) {
        let property = col.column.property;
        let content = '';
        let title = '';
        switch (property) {
          case 'qualifiedCount': {
            content = '仓库内真实合格货品数量';
            title = '合格';
            break;
          }
          case 'unqualifiedCount': {
            content = '仓库内真实不合格货品数量';
            title = '不合格';
            break;
          }
          case 'transitCount': {
            content = '在运输中的货品数量';
            title = '在途库存';
            break;
          }
          case 'totalCount': {
            content = '用于计算资产';
            title = '库存总数';
            break;
          }
          case 'availableCount': {
            content = '用于出库订单的控制，表明可销售的数量';
            title = '合格';
            break;
          }
          case 'unqualifiedBizCount': {
            content = '用于不合格品退货订单控制';
            title = '不合格';
            break;
          }
          case 'undeterminedCount': {
            content = '仓库内质量状态待确定而不允许销售的库存数';
            title = '业务停销';
            break;
          }
        }
        return (
          <el-tooltip effect="dark" content={content} placement="top">
            <span>{title}</span>
          </el-tooltip>
        );
      },
      showDetail(item) {
        this.currentItemId = item.id;
        this.currentItem = item;
        this.showDetailPart = true;
      },
      resetRightBox() {
        this.showDetailPart = false;
      },
      searchInOrder: function () {// 搜索
        Object.assign(this.filters, this.searchWord);
      },
      resetSearchForm: function () {// 重置表单
        let temp = {
          batchNumberId: '',
          goodsId: '',
          warehouseId: '',
          supplyManufacturersId: '',
          showFlag: true
        };
        Object.assign(this.searchWord, temp);
        Object.assign(this.filters, temp);
        this.batches = [];
      },
      orgGoodsChange(val) {
        this.searchWord.batchNumberId = '';
        this.batchNumberList = [];
        this.batches = [];
        this.queryDhsBatchNumbers();
      },
      batchNumberChange(val) {
        if (!val) {
          this.filters.batchNumberId = '';
          this.batches = [];
          return;
        }
        this.searchInOrder();
        this.getBatches(1);
      },
      queryDhsBatchNumbers(val) {
        if (!this.searchWord.goodsId) {
          this.batchNumberList = [];
          this.$notify.info('请选择货品主档');
          return;
        }
        this.queryDhsBatchNumberList({
          keyWord: val,
          goodsId: this.searchWord.goodsId
        });
      },
      logisticsCentreChange() {
        this.searchInOrder();
        this.getBatches(1);
      },
      supplyManufacturersIdChange() {
        this.searchInOrder();
        this.getBatches(1);
      },
      formatTime(date) {
        return date ? this.$moment(date).format('YYYY-MM-DD') : '';
      },
      onSubmit() {
        if (!this.searchWord.goodsId) {
          this.$notify.info({
            message: '请选择货品主档'
          });
          return;
        }
        if (!this.searchWord.batchNumberId) {
          this.$notify.info({
            message: '请选择批号'
          });
          return;
        }
        if (this.form.reason) {
          if (this.form.reason !== '0') {
            let item = this.adjustReason.find(f => f.key === this.form.reason);
            this.form.remark = item && item.label || this.form.reason;
            delete this.form.reason;
          }
        }
        this.$confirm('是否调整库存，请谨慎操作', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          let obj = Object.assign({}, this.form, this.searchWord);
          this.doing = true;
          this.$http.put('/bsp-stock/adjust', obj).then(() => {
            this.doing = false;
            this.$notify.success({
              message: '调整库存成功'
            });
            this.getBatches(1);
            this.form = {
              availableCount: '',
              qualifiedCount: '',
              transitCount: '',
              unqualifiedCount: '',
              reason: '',
              remark: ''
            };
          });
        }).catch(error => {
          this.doing = false;
          this.$notify.error({
            message: error.response.data && error.response.data.msg || '调整库存失败'
          });
        });
      }
    }
  };
</script>
